import React from 'react';
import moment from 'moment';
import Dotdotdot from 'react-dotdotdot';

import SportLabel from '../../../cards/CardComponents/SportLabel';

import config from '../../../../../config';
import { ageDisplay, ratingTypes } from '../../../../utils/constants';
import { sportTypeIds } from '../../../../utils/eventConstants';

const genderTypes = {
    1: 'Co-ed',
    2: 'Male',
    3: 'Female',
};

const sessionTypes = {
    1: 'Team Tournament',
    2: 'Multi-Round',
};

const MIN_UTRP_RATING = 1;

const LeaguesEventCard = ({ session }) => {
    const { conferenceMinAge, conferenceMaxAge, sportTypeId, conferenceMinUtr, conferenceMaxUtr } = session || {};
    const location = session?.location?.placeName || session?.location?.formattedAddress || '';
    const isTennisMatch = sportTypeId === sportTypeIds.TENNIS;
    const ageRange = ageDisplay([conferenceMinAge, conferenceMaxAge]);
    const ratingType = isTennisMatch ? ratingTypes.tennis : ratingTypes?.pickleball;
    const conferenceMinRating = conferenceMinUtr === 0 ? MIN_UTRP_RATING : conferenceMinUtr;
    const conferenceRating = `${conferenceMinRating?.toFixed(1)} - ${conferenceMaxUtr?.toFixed(1)}`;
    const conferenceDetails = `${ratingType} ${conferenceRating} \u2022 ${ageRange} \u2022 ${genderTypes[session?.conferenceGenderTypeId]}`;

    const getFormattedDate = () => {
        const startDate = moment.utc(session?.sessionStartDate);
        const today = moment.utc().startOf('day');
        const yesterday = moment.utc().subtract(1, 'days').startOf('day');
        const tomorrow = moment.utc().add(1, 'days').startOf('day');
        const isToday = startDate.isSame(today, 'd');
        const isYesterday = startDate.isSame(yesterday, 'd');
        const isTomorrow = startDate.isSame(tomorrow, 'd');
        const time = startDate.local().format('h:mm a');
        let dateString;

        if (isToday) {
            dateString = 'today';
        } else if (isYesterday) {
            dateString = 'yesterday';
        } else if (isTomorrow) {
            dateString = 'tomorrow';
        } else {
            dateString = startDate.local().format('MMM D');
        }

        const formattedDate = `${dateString} | ${time}`;

        return formattedDate.toUpperCase();
    };

    return (
        <a href={`${config.leaguesAppHost}/leagues/session/${session?.sessionId}`}>
            <div className={'utr-card event-card'}>
                <SportLabel sportTypeId={sportTypeId} />
                <div className={`card-view d-block`}>
                    <div className="content-wrapper">
                        <div className="club-and-name">
                            <div className="date">
                                <span>{getFormattedDate()}</span>
                            </div>
                            <div className={`name hasSanctioned`} title={session?.sessionName}>
                                <Dotdotdot clamp={2}>{session?.sessionName}
                                    <div className={`badge-wrapper`}>
                                        <div className={`utr-icon icon-verified-blue`} title="Sanctioned" />
                                    </div>
                                </Dotdotdot>
                            </div>
                            <div className="club-name show-ellipsis">{session?.conferenceName}</div>
                        </div>
                        <div className="description">
                            <div>{`${sessionTypes[session?.sessionTypeId]} ${location ? `\u2022 ${location}` : ''}`}</div>
                            <div>{conferenceDetails}</div>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    );
};

export default LeaguesEventCard;
